import { createFileRoute } from '@tanstack/react-router';

import { MainTendersPage } from '@/features/owner/tenders-page';

export const Route = createFileRoute('/_app/projects/$projectId/tenders/')({
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  return <MainTendersPage projectId={projectId} />;
}
